export default __webpack_public_path__ + "static/media/icon-freeplay.bd29b09d.svg";